export const BASE_DELAY = 1000
